/* tslint:disable */
/* eslint-disable */
/**
 * Viterbit API
 * This is the documentation for viterbit\'s apps
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateCompanyCommand
 */
export interface CreateCompanyCommand {
    /**
     * 
     * @type {string}
     * @memberof CreateCompanyCommand
     */
    name: string;
}

/**
 * Check if a given object implements the CreateCompanyCommand interface.
 */
export function instanceOfCreateCompanyCommand(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "name" in value;

    return isInstance;
}

export function CreateCompanyCommandFromJSON(json: any): CreateCompanyCommand {
    return CreateCompanyCommandFromJSONTyped(json, false);
}

export function CreateCompanyCommandFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateCompanyCommand {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': json['name'],
    };
}

export function CreateCompanyCommandToJSON(value?: CreateCompanyCommand | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
    };
}

